<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <PortionSettings />
  </v-container>
</template>
<script>
import PortionSettings from "../components/PortionSettings.vue";
export default {
  components: {
    PortionSettings
  },
  created() {
    if (!this.hasRole(this.AdminUserPermissions.SETTINGS_VIEW)) {
      this.$router.push({
        name: "Error404"
      });
    }
  }
};
</script>

